export default {
  HIGHLIGHT_BACKGROUND: "#f2f2ab",
  BRAND_PRIMARY_COLOR_1: "#104D82",
  BRAND_PRIMARY_COLOR_2: "#0461DE",
  BRAND_PRIMARY_COLOR_3: "#009BDB",
  LIGHT_GRAY: "#D3D3D3",
};
